import api from './axiosInstance';

export const getAll = () => api.get('/groups');
export const getById = (id) => api.get(`/groups/${id}`);
export const create = (data) => api.post('/groups', data);
export const update = (id, data) => api.put(`/groups/${id}`, data);
export const remove = (id) => api.delete(`/groups/${id}`);
export const setDefault = (id) => api.post(`/groups/${id}/set-default`);
